._tooltip-content__title_7ivyw_1 {
  padding-bottom: 6px; }

._tooltip-content__link_7ivyw_4 {
  padding-top: 6px; }
